<style scoped lang="scss">
    @import "../../styles/hos";
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pt15 pl15 pr15 pb15 flex">
            <div class="flex1 pr15">
                <referral-base-form ref="baseForm" :againDetail="againDetail"></referral-base-form>
                <referral-condition-form ref="conditionForm"></referral-condition-form>
            </div>
            <div class="flex1 blshow pl15">
                <referral-apply-form ref="applyForm">
                    <template slot="buttonGroup">
                        <hos_button content="返回" @clickEvent="$router.go(-1)"></hos_button>
                        <hos_button content="确认申请" type="affirm" class="ml80" @clickEvent="doReferralAction('提交申请')"></hos_button>
                    </template>
                </referral-apply-form>
                <!--<div class="flex jcc mt15">-->
                    <!--<el-button size="mini" @click="$router.back()">返回</el-button>-->
                    <!--<el-button type="primary" size="mini" @click="doReferralAction('提交申请')">提交申请</el-button>-->
                <!--</div>-->
            </div>
        </div>
        <!--<div class="pl15 pr15 pb15">-->
            <!--<referral-base-form ref="baseForm" :value="form"></referral-base-form>-->
            <!--<referral-condition-form ref="conditionForm"></referral-condition-form>-->
            <!--<referral-apply-form ref="applyForm"></referral-apply-form>-->
            <!--<div class="flex jcc mt15">-->
                <!--<el-button size="mini" @click="$router.back()">返回</el-button>-->
                <!--<el-button type="primary" size="mini" @click="doReferralAction('提交申请')">提交申请</el-button>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
  import {referralMixin} from "../../lib/mixins/referral";
  import hos_button from "../../components/hos/hos-button"
  import Breadcrumb from "../../components/common/Breadcrumb";
  import ReferralBaseForm from "../../components/referral/base-form";
  import ReferralConditionForm from "../../components/referral/condition-form";
  import ReferralApplyForm from "../../components/referral/apply-form";
  import {isEmpty, pickByArray} from "../../lib/utils";

  export default {
    name: "ReferralApply",
    data() {
      return {
        form: {},
          againDetail:{}
      }
    },
    computed: {},
    components: {ReferralApplyForm, ReferralConditionForm, ReferralBaseForm, Breadcrumb,hos_button},
    mixins: [referralMixin],
    created() {

    },
    mounted() {
        //再次申请
        if(this.$route.query.again){
            const cache = this.$cache.get('referralOrderCache');
            console.log(cache)
            this.againDetail = cache;
            // if (!isEmpty(cache)) {
            //     Log('cache', cache);
            //     this.form = {...this.form, ...pickByArray(cache, ['patName', 'patIdcard', 'patAge', 'patMobile', 'consulterMobile', 'otherContactWay', 'docTelphone', 'patJob', 'areaCode', 'address','areaName'])}
            // }
        }
    },
    beforeDestroy() {

    },
    methods: {}
  }
</script>
